import {FormState} from "./FormState";
import { crearMascota, NuevaMascota, Sexo, Temperamento } from '../../../services/mascotasServicios';

const generarNuevaMascota = (formState: FormState, idPropietario: string): NuevaMascota => {
    let temperamento: Temperamento | undefined = undefined;
    
    if(formState.temperamento.value){
        temperamento = formState.temperamento.value as Temperamento;
    }

    return {
        idPropietario: idPropietario,
        nombre: formState.nombre.value,
        idRaza: formState.raza.value,
        sexo: formState.sexo.value as Sexo,
        fechaNacimiento: formState.fechaNacimiento.value,
        fechaIngreso: formState.fechaIngreso.value,
        foto: formState.foto.value,
        certificadoVacuna: formState.certificadoVacuna.value,
        estaEsterilizada: formState.estaEsterilizada.value,
        tieneCondicionMedica: formState.tieneCondicionMedica.value,
        observacionesMedicas: formState.observacionesMedicas.value,
        temperamento: temperamento,
        observacionesTemperamento: formState.observacionesTemperamento.value,
        observacionesAlimenticias: formState.observacionesAlimenticias.value,
        nombreVeterinario: formState.nombreVeterinario.value,
        comentarios: formState.comentarios.value,
        fechaGarrapaticida: formState.fechaGarrapaticida.value,
        fechaVacuna: formState.fechaVacuna.value,
        mesesPeriodicidadGarrapaticida: formState.mesesPeriodicidadGarrapaticida.value !== "" ? parseInt(formState.mesesPeriodicidadGarrapaticida.value) : undefined,
    };
}

export const crearNuevaMascota = async (formState: FormState, idPropietario: string) => {
    const nuevaMascota = generarNuevaMascota(formState, idPropietario);
    await crearMascota(nuevaMascota);
}